import { MutationTree } from 'vuex';
import { IIntegrationStatus } from '@/settings/integrations/types/integration-list-item';
import { IIntegrationModalDetails } from '@/settings/integrations/types/integration-modal';
import { EIntegrationMutations } from '@/settings/integrations/store/integrations.constants';
import { IIntegrationState } from '@/settings/integrations/store/integrations.types';

export const mutations: MutationTree<IIntegrationState> = {
  [EIntegrationMutations.SetLoading](state: IIntegrationState, loading: boolean) {
    state.loading = loading;
  },
  [EIntegrationMutations.SetLoaded](state: IIntegrationState, loaded: boolean) {
    state.loaded = loaded;
  },
  [EIntegrationMutations.SetIntegrations](
    state: IIntegrationState,
    integrations: IIntegrationStatus[]
  ) {
    state.status = integrations;
  },
  [EIntegrationMutations.SetModalMeta](
    state: IIntegrationState,
    integrationModalDetails: IIntegrationModalDetails
  ) {
    state.details = integrationModalDetails;
  },
  [EIntegrationMutations.SetState](state: IIntegrationState, newState: IIntegrationState) {
    state.status = newState.status;
    state.details = newState.details;
    state.loaded = newState.loaded;
    state.loading = newState.loading;
  },
};
